import PaymentMethod from "./payment-method";

export default PaymentMethod